import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { API, inr, logErr } from "../../lib/api";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState(null);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    document.title = "Customers | Admin";
    API.get("/admin/customers").then((r) => setCustomers(r.data)).catch((err) => logErr("Failed to load customers:", err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const open = async (id) => {
    const r = await API.get(`/admin/customers/${id}`);
    setDetail(r.data);
  };

  if (!customers) return <div className="text-muted-foreground">Loading...</div>;

  return (
    <div data-testid="admin-customers">
      <h1 className="font-display font-black text-3xl tracking-tighter mb-8">Customers <span className="text-muted-foreground text-lg font-normal">({customers.length})</span></h1>
      <div className="border border-[#262626] bg-ink-surface overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-[0.2em] text-muted-foreground border-b border-[#262626]">
              <th className="p-4">Name</th><th className="p-4">Email</th><th className="p-4">Joined</th>
              <th className="p-4">Orders</th><th className="p-4">Total spent</th><th className="p-4"></th>
            </tr>
          </thead>
          <tbody>
            {customers.map((c) => (
              <tr key={c.id} className="border-b border-[#262626] hover:bg-ink-elevated/50 cursor-pointer" onClick={() => open(c.id)} data-testid={`customer-row-${c.email}`}>
                <td className="p-4 font-bold text-xs">{c.name}</td>
                <td className="p-4 text-xs text-muted-foreground">{c.email}</td>
                <td className="p-4 text-xs text-muted-foreground">{c.created_at.slice(0, 10)}</td>
                <td className="p-4 text-xs">{c.order_count}</td>
                <td className="p-4 text-xs font-bold text-gold">{inr(c.total_spent)}</td>
                <td className="p-4 text-xs text-gold">View →</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {detail && (
        <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/70 p-4" data-testid="customer-detail-modal">
          <div className="bg-ink-surface border border-[#262626] w-full max-w-xl p-6 my-8">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="font-display font-bold text-xl">{detail.name}</h2>
                <p className="text-xs text-muted-foreground">{detail.email}{detail.phone ? ` · ${detail.phone}` : ""}</p>
              </div>
              <button onClick={() => setDetail(null)} data-testid="close-customer-detail"><X size={18} /></button>
            </div>
            <p className="text-[10px] uppercase tracking-[0.2em] text-gold font-bold mb-3">Order history</p>
            {detail.orders.length === 0 && <p className="text-xs text-muted-foreground">No orders yet.</p>}
            <div className="space-y-2">
              {detail.orders.map((o) => (
                <div key={o.id} className="flex items-center justify-between border border-[#262626] p-3 text-xs">
                  <div>
                    <p className="font-bold">{o.order_number}</p>
                    <p className="text-muted-foreground">{o.created_at.slice(0, 10)} · {o.status.replace(/_/g, " ")}</p>
                  </div>
                  <p className="font-bold text-gold">{inr(o.total)}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
